import React, { useState, useEffect, useRef } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./BlackCalendarTheme.css";
import EventIcon from "@material-ui/icons/Event";
import IconButton from "@material-ui/core/IconButton";
import Helper from "../../common/Helper";

export default function ScheduleDatePicker(props) {
    // 1. Accept a 'side' prop (default to 'right' to preserve existing behavior)
    const { side = "right" } = props;

    const [isOpen, setIsOpen] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [allowedDates, setAllowedDates] = useState([]);
    const calendarRef = useRef(null);

    useEffect(() => {
        setSelectedDate(props.selectedDate);
        const handleClickOutside = (event) => {
            if (
                isOpen &&
                calendarRef.current &&
                !calendarRef.current.contains(event.target)
            ) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen, props.selectedDate]);

    useEffect(() => {
        const formattedDates = (props.calenderDates || [])
            .map((item) => {
                const value = item?.gameDate || item;
                const date = new Date(value);
                return Number.isNaN(date.getTime()) ? null : formatDateString(date);
            })
            .filter(Boolean);

        setAllowedDates(formattedDates);
    }, [props.calenderDates]);

    const formatDateString = (dateValue) => {
        const date = dateValue instanceof Date ? dateValue : new Date(dateValue);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    const tileDisabled = ({ date: tileDate, view }) => {
        if (view === "month") {
            const tileString = formatDateString(tileDate);
            return !allowedDates.includes(tileString);
        }
        return false;
    };

    const toggleCalendar = () => setIsOpen(!isOpen);

    const handleDateChange = (date) => {
        setSelectedDate(date);
        setIsOpen(false);
        let formattedDate = Helper.FormatDateMMDDYYYY_WithoutTime(date);
        props.handleDateSelection(formattedDate);
    };

    // 2. Determine container alignment and INVERTED calendar position
    const isLeftSide = side === "left";
    const justifyContent = isLeftSide ? "flex-start" : "flex-end";

    // If icon is on the left, open calendar on the right (right: auto, left: 0)
    // If icon is on the right, open calendar on the left (left: auto, right: 0)
    const calendarPlacementStyles = isLeftSide
        ? { left: "15px", right: "auto" }
        : { right: "15px", left: "auto" };

    const positioning = isLeftSide
        ? { left: "-14px", }
        : { right: "-14px", };

    return (
            <div
                ref={calendarRef}
                style={{ position: "absolute", top: '0', display: "inline-block", zIndex: '10', ...positioning }}
            >
                <IconButton onClick={toggleCalendar} style={{ color: "#B5B5B5" }}>
                    <EventIcon />
                </IconButton>

                {isOpen && (
                    <div
                        style={{
                            position: "absolute",
                            top: "100%",
                            marginTop: "8px",
                            zIndex: 100,
                            ...calendarPlacementStyles, // Dynamically flip the dropdown direction
                        }}
                    >
                        <div className="custom-black-calendar">
                            <Calendar
                                onChange={handleDateChange}
                                value={selectedDate}
                                tileDisabled={tileDisabled}
                            />
                        </div>
                    </div>
                )}
            </div>
    );
}
